/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface ChallengeBase
 */
export interface ChallengeBase {
    /**
     * 
     * @type {string}
     * @memberof ChallengeBase
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof ChallengeBase
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof ChallengeBase
     */
    authentication_method: FactorMethod;
}

/**
 * Check if a given object implements the ChallengeBase interface.
 */
export function instanceOfChallengeBase(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function ChallengeBaseFromJSON(json: any): ChallengeBase {
    return ChallengeBaseFromJSONTyped(json, false);
}

export function ChallengeBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
    };
}

export function ChallengeBaseToJSON(value?: ChallengeBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
    };
}

